<template>
  <SearchBox
    :label="((label) ? label : 'Plano Financeiro') + ':'"
    ref="searchbox"
    placeholder="Busca Plano Financeiro por Nome ou Código"
    funcaoBuscar="getPlanosFinanceiroLista"
    :parametros="parametros"
    @selected="handleSelected"
  />
</template>

<style lang="scss" scoped></style>

<script>
import SearchBox from "./SearchBox.vue";

export default {
  name: "SearchBoxPlanoFinanceiro",
  data() {
    return {
      item: {}
    };
  },
  props: ["value", "label", "pagarReceber"],
  components: {
    SearchBox
  },
  computed: {
    parametros() {
      let obj = {
        PAGAR_RECEBER: this.pagarReceber
      };

      return obj;
    }
  },
  methods: {
    handleSelected(item) {
      this.item = item;
      if (item.ID) {
        this.$emit("input", item.ID);
        this.$emit("descricao", item.DESCRICAO);
        this.$emit("update:modelValue", item.ID);
        this.$emit("change", {});
      } else {
        this.$emit("input", "");
        this.$emit("descricao", "");
        this.$emit("update:modelValue", "");
        this.$emit("change", {});
      }
    },
    selecionar(item) {
      this.item = item;
      this.$refs.searchbox.selecionarItemExterno(item);
    },
    apagar() {
      this.$refs.searchbox.apagar(true);
    },
    obterItem() {
      return this.item;
    }
  }
};
</script>
